<template>
  <MessageSuggestions>
    <MessageSuggestionButton
      v-for="response in candidateResponsesFiltered"
      :key="response"
      class="tw:md:w-full tw:@md:md:w-fit"
      @click="onQuickRespond(response)"
    >
      {{ response }}
    </MessageSuggestionButton>
  </MessageSuggestions>
</template>

<script setup>
import difference from 'lodash/difference'
import { computed } from 'vue'
import { MessageSuggestionButton, MessageSuggestions } from '@/components/common/message'
import { useQuickConversation } from './use-quick-conversation'

const { candidateResponses, candidateResponsesClicked, composeForm, checkAndSend } = useQuickConversation()

const candidateResponsesFiltered = computed(() => {
  return difference(candidateResponses.value, candidateResponsesClicked.value)
})

function onQuickRespond(response) {
  candidateResponsesClicked.value = [
    ...candidateResponsesClicked.value,
    response,
  ]

  composeForm.draft = response
  checkAndSend()
}
</script>
